export default {

  userList: (state) => {
    return state.userList[0];
  },
  userListOptions: (state) => {
    const options = [];
    state.userList.forEach((item) => {
      const pushItem = {
        value: item.userId,
        text: item.fname + ' ' + item.lname + ' | ' + item.personCode ,
      };
      options.push(pushItem);
    });
    return options;
  },
  userInfo: (state) => {
    return state.userInfo;
  },
  userJobs: (state) => {
    return state.userJobs;
  },
  assetList: (state) => {
    return state.assetList;
  },

  groupList: (state) => {
    return state.groupList;
  },
  groupNames: (state) => {
    return state.groupNames;
  },
  groupMembers: (state) => {
    return state.groupMembers;
  },

  noticeGroup: (state) => {
    return state.noticeGroup;
  },
  noticeList: (state) => {
    return state.noticeList;
  },
  userNoticeList: (state) => {
    return state.userNoticeList;
  },
  userArchiveNoticeList: (state) => {
    return state.userArchiveNoticeList;
  },
  managerNoticeList: (state) => {
    return state.managerNoticeList;
  },
  managerHistoryNoticeList: (state) => {
    return state.managerHistoryNoticeList;
  },
  noticeDetails: (state) => {
    return state.noticeDetails;
  },
  userNoticeDetails: (state) => {
    return state.userNoticeDetails;
  },

  fileAddress: (state) => {
    return state.fileAddress;
  },





};
